/* Copyright (c) 2026 Dobler Data Solutions, LLC. All rights reserved. */

import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './authConfig';
import { RequireAuth } from './components/auth/RequireAuth';
import { RequireRole } from './components/auth/RequireRole';
import { MainLayout } from './components/layout/MainLayout';
import { FormulaListPage } from './pages/FormulaListPage';
import { AssignmentPage } from './pages/AssignmentPage';
import { DashboardPage } from './pages/DashboardPage';
import { SettingsPage } from './pages/SettingsPage';
import { TaxonomyPage } from './pages/TaxonomyPage';
import { HelpPage } from './pages/HelpPage';
import { UserManagementPage } from './pages/UserManagementPage';
import { UnauthorizedPage } from './pages/UnauthorizedPage';

export function App() {
  return (
    <MsalProvider instance={msalInstance}>
      <BrowserRouter>
        <RequireAuth>
          <Routes>
            <Route element={<MainLayout />}>
              <Route
                path="/formulas"
                element={
                  <RequireRole minimumRole="Pharmacist">
                    <FormulaListPage />
                  </RequireRole>
                }
              />
              <Route
                path="/formulas/:setId"
                element={
                  <RequireRole minimumRole="Pharmacist">
                    <AssignmentPage />
                  </RequireRole>
                }
              />
              <Route
                path="/dashboard"
                element={
                  <RequireRole minimumRole="Manager">
                    <DashboardPage />
                  </RequireRole>
                }
              />
              <Route
                path="/taxonomy"
                element={
                  <RequireRole minimumRole="Pharmacist">
                    <TaxonomyPage />
                  </RequireRole>
                }
              />
              <Route
                path="/users"
                element={
                  <RequireRole minimumRole="Admin">
                    <UserManagementPage />
                  </RequireRole>
                }
              />
              <Route
                path="/settings"
                element={
                  <RequireRole minimumRole="Pharmacist">
                    <SettingsPage />
                  </RequireRole>
                }
              />
              <Route
                path="/help"
                element={
                  <RequireRole minimumRole="Pharmacist">
                    <HelpPage />
                  </RequireRole>
                }
              />
              <Route path="/unauthorized" element={<UnauthorizedPage />} />
              <Route path="/" element={<Navigate to="/formulas" replace />} />
              <Route path="*" element={<Navigate to="/formulas" replace />} />
            </Route>
          </Routes>
        </RequireAuth>
      </BrowserRouter>
    </MsalProvider>
  );
}
